import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { mapObjIndexed, includes } from 'ramda';

export const { Types: ContentRegistryTypes, Creators: ContentRegistryActions } = createActions(
  {
    addEntities: ['newEntities', 'prune'],
    setIsLoading: ['isLoading'],
    fetchAllMarkets: null,
    fetchAllMarketsFinished: null,
    fetchExperience: ['slug'],
    fetchExperienceById: ['id'],
    fetchKiosk: ['slug'],
    fetchMarket: ['slug', 'threshold'],
    fetchMarketExperiences: ['marketId'],
    fetchMarketExperiencesFinished: ['marketId'],
    fetchAppConfig: [],
    recentUpdate: null,
    startListeningContentUpdate: [],
    stopListeningContentUpdate: [],
    setRecentContentUpdate: ['recentUpdate', 'shouldSkipFetching'],
    persist: [],
    rehydrate: [],
    rehydrateSuccess: ['entities'],
  },
  { prefix: 'CONTENT_REGISTRY/' }
);

export const INITIAL_STATE = Immutable(
  {
    entities: {
      assets: {},
      experiences: {},
      markets: {},
      categories: {},
      kioskModes: {},
      vendors: {},
      testimonials: {},
      appConfig: {},
      websiteConfig: {},
      featuredExperiencesSections: {},
      partners: {},
      footer: {},
      regions: {},
      quotes: {},
      stories: {},
      guides: {},
      newsletters: {},
    },
    isFetching: {
      allMarkets: false,
      marketExperiences: {},
    },
    isRehydrated: false,
    recentUpdate: null,
  },
  'ContentRegistry'
);

const addEntities = (state, { newEntities, prune = [] }) =>
  state.update(
    'entities',
    mapObjIndexed((entitiesByType, type) => {
      const shouldPrune = includes(type, prune);
      const newTypeEntities = newEntities[type] || {};
      return shouldPrune ? newTypeEntities : entitiesByType.merge(newTypeEntities);
    })
  );

const rehydrateSuccess = (state, { entities = {} }) =>
  state
    .set('isRehydrated', true)
    .update('entities', mapObjIndexed((entitiesByType, type) => Immutable(entities[type] || {})));

const setRecentContentUpdate = (state, { recentUpdate }) => state.set('recentUpdate', recentUpdate);

const fetchMarketExperiences = (state, { marketId }) =>
  state.setIn(['isFetching', 'marketExperiences', marketId], true);

const fetchMarketExperiencesFinished = (state, { marketId }) =>
  state.setIn(['isFetching', 'marketExperiences', marketId], false);

const fetchAllMarketsHandler = state => state.setIn(['isFetching', 'allMarkets'], true);
const fetchAllMarketsFinishedHandler = state => state.setIn(['isFetching', 'allMarkets'], false);

export const reducer = createReducer(INITIAL_STATE, {
  [ContentRegistryTypes.ADD_ENTITIES]: addEntities,
  [ContentRegistryTypes.SET_RECENT_CONTENT_UPDATE]: setRecentContentUpdate,
  [ContentRegistryTypes.REHYDRATE_SUCCESS]: rehydrateSuccess,
  [ContentRegistryTypes.FETCH_MARKET_EXPERIENCES]: fetchMarketExperiences,
  [ContentRegistryTypes.FETCH_MARKET_EXPERIENCES_FINISHED]: fetchMarketExperiencesFinished,
  [ContentRegistryTypes.FETCH_ALL_MARKETS]: fetchAllMarketsHandler,
  [ContentRegistryTypes.FETCH_ALL_MARKETS_FINISHED]: fetchAllMarketsFinishedHandler,
});
